import React from "react";

// -------------------import style---------------------------------
import { ContainerDiv } from "./TravelThroughPTC.styled";

// -----------------import images--------------------------------

const TravelThroughPTC = () => {
  return (
    <ContainerDiv>
      <h1>Travel Through PTC</h1>
      <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Temporibus
        obcaecati atque totam! Libero enim dignissimos dolorum sed quis voluptas
        expedita, dolor ipsum debitis ratione voluptatem esse ut a. Expedita,
        alias.
        <br />
        <br />
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Cupiditate,
        vero! Exercitationem eos facere, quo tempore beatae dolore corporis
        culpa reprehenderit nihil. Totam consectetur fugit tenetur blanditiis
        error? Eveniet, facilis laboriosam?
        <br />
        <br />
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Facilis aut
        est ullam, cum nemo accusantium perspiciatis, voluptas porro totam sint
        recusandae atque quasi consequatur aspernatur exercitationem sit, animi
        ex eius?
      </p>
    </ContainerDiv>
  );
};

export default TravelThroughPTC;
